/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PartnerIdWithParentId
 */
export interface PartnerIdWithParentId {
    /**
     * 
     * @type {number}
     * @memberof PartnerIdWithParentId
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof PartnerIdWithParentId
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PartnerIdWithParentId
     */
    email: string;
    /**
     * 
     * @type {number}
     * @memberof PartnerIdWithParentId
     */
    parentId: number;
}

/**
 * Check if a given object implements the PartnerIdWithParentId interface.
 */
export function instanceOfPartnerIdWithParentId(value: object): value is PartnerIdWithParentId {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('parentId' in value) || value['parentId'] === undefined) return false;
    return true;
}

export function PartnerIdWithParentIdFromJSON(json: any): PartnerIdWithParentId {
    return PartnerIdWithParentIdFromJSONTyped(json, false);
}

export function PartnerIdWithParentIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartnerIdWithParentId {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'email': json['email'],
        'parentId': json['parent_id'],
    };
}

export function PartnerIdWithParentIdToJSON(json: any): PartnerIdWithParentId {
    return PartnerIdWithParentIdToJSONTyped(json, false);
}

export function PartnerIdWithParentIdToJSONTyped(value?: PartnerIdWithParentId | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'email': value['email'],
        'parent_id': value['parentId'],
    };
}

